// Following labels store
import Labels from '../schema/Labels';
import assign from 'latest_modules/lodash/assign';

import labelsApi from '../../api/labels';
import {
  LABELS as labelsTypes
} from '../mutation-types';

// getters
const getters = assign(Labels.getters, {
  isFollowingLabelById(state, getters) {
    return function(id) {
      if (!getters.findById(id)) {
        return false;
      }
      return getters.findById(id).is_following;
    };
  }
});

// Actions
const actions = {
  /*
  フォローしているラベルを取得する
  @param {String} id ラベルID IDを指定すると対象のラベルをフォローしていると結果が返る。IDを指定しなければフォローしているラベル全件取得
  */
  fetch({
    commit
  }, payload) {
    return new Promise(function(resolve, reject) {
      labelsApi.get(payload, function(err, res) {
        if (err) {
          return reject(err);
        }
        if (res && res.labels) {
          for (let label of res.labels) {
            commit(labelsTypes.ADD, label);
          }
        }
        resolve(res);
      });
    });
  },

  /*
  ラベルをフォローする
  @param {String} id ラベルID
  */
  follow({
    commit,
    getters
  }, id) {
    return new Promise(function(resolve, reject) {
      labelsApi.post(id, function(err) {
        if (err) {
          return reject(err);
        }
        // state に存在しなければ id だけのデータを作成
        if (!getters.findById(id)) {
          commit(labelsTypes.ADD, {
            id
          });
        }
        commit(labelsTypes.FOLLOW, id);
        // GA
        const labelName = getters.findById(id).name;
        window.tom.helper.ga.push([
          'event',
          'LabelFollow',
          'Follow',
          labelName,
          1
        ]);
        resolve(getters.findById(id));
      });
    });
  },

  /*
  ラベルのフォローを解除する
  @param {String} id ラベルID
  */
  unfollow({
    commit,
    getters
  }, id) {
    return new Promise(function(resolve, reject) {
      labelsApi.delete(id, function(err) {
        if (err) {
          return reject(err);
        }
        // state に存在しなければ id だけのデータを作成
        if (!getters.findById(id)) {
          commit(labelsTypes.ADD, {
            id
          });
        }
        commit(labelsTypes.UNFOLLOW, id);
        // GA
        const labelName = getters.findById(id).name;
        window.tom.helper.ga.push([
          'event',
          'LabelFollow',
          'UnFollow',
          labelName,
          1
        ]);
        resolve(getters.findById(id));
      });
    });
  },

  /*
  ラベルのフォローまたはフォロー解除をトグルする
  @param {String} id ラベルID
  */
  toggle({
    getters,
    dispatch
  }, id) {
    const label = getters.findById(id);
    if (label && label.is_following) {
      dispatch('unfollow', id);
    } else {
      dispatch('follow', id);
    }
  }
};

// Mutations
const mutations = {
  [labelsTypes.ADD](state, payload) {
    Labels.update({
      _id: payload.id
    }, {
      _id: payload.id,
      name: payload.name,
      type: payload.type,
      is_following: true
    }, {
      upsert: true
    });
  },

  [labelsTypes.FOLLOW](state, id) {
    Labels.updateById(id, {
      is_following: true
    });
  },

  [labelsTypes.UNFOLLOW](state, id) {
    Labels.updateById(id, {
      is_following: false
    });
  }
};

export default {
  namespaced: true,
  state: Labels.state,
  getters,
  actions,
  mutations
};
